var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.5H2V18.5H3V11.531C3 6.543 7.03 2.5 12 2.5C16.97 2.5 21 6.543 21 11.531V18.5H22V20.5ZM5 18.5H19V11.531C19 7.648 15.866 4.5 12 4.5C8.134 4.5 5 7.648 5 11.531V18.5ZM9.5 21.5H14.5C14.5 22.163 14.2366 22.7989 13.7678 23.2678C13.2989 23.7366 12.663 24 12 24C11.337 24 10.7011 23.7366 10.2322 23.2678C9.76339 22.7989 9.5 22.163 9.5 21.5Z",
    fill: "#B45436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.98d14c2b8a8475a4efbad554beb1c4b6.svg";
export { ForwardRef as ReactComponent };